import React from 'react';

import PropTypes from 'prop-types';
import { faSpinnerThird } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';

const SubmitButton = ({ children, disabled = false, isLoading = false }) => {
  if (isLoading) {
    return (
      <Button disabled>
        <FontAwesomeIcon className="animate-spin" icon={faSpinnerThird} />
        Please wait
      </Button>
    );
  }

  return (
    <Button disabled={disabled} type="submit">
      {children}
    </Button>
  );
};

SubmitButton.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default SubmitButton;
